import { render, staticRenderFns } from "./important_message_bar.vue?vue&type=template&id=7ce5b09c&"
import script from "./important_message_bar.vue?vue&type=script&lang=js&"
export * from "./important_message_bar.vue?vue&type=script&lang=js&"
import style0 from "./important_message_bar.vue?vue&type=style&index=0&id=7ce5b09c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports